module.exports = __webpack_public_path__ + "static/media/S2CE.db6f05af.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/S2CE.jpg
// module id = 86
// module chunks = 0